import template from './modalCoachmark.html';
import controller from './modalCoachmark.controller';
import './modalCoachmark.scss';

let modalCoachmarkComponent = {
  restrict: 'E',
  bindings: {
    isInception: '<',
    coachmarkDismissed: '&',
    data: '<',
    userId:'<',
  },
  template,
  controller
};

export default modalCoachmarkComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalCoachmark/modalCoachmark.component.js